import { Button, Column, Columns } from '@codeparva/ui-components-library';
import { Field, useField } from 'formik';
import React from 'react';
import { ContactUsPageTypes } from '../ContactUsPageTypes';

const buttonColor = 'accent';

export const GetNewContactUs = ({ label, variant, ...props }: any) => {
  const [field] = useField(props);
  return variant === 'newContactUsLightTheme' ? (
    <fieldset>
      <legend className="pl-1 pr-1">
        {label}
        <GetAsterisk />
      </legend>
      <Field className="input" {...field} {...props} />
    </fieldset>
  ) : (
    <div className="is-flex is-flex-direction-column">
      <label>
        {label}
        <GetAsterisk />
      </label>
      <Field className="standardInput" {...props} />
    </div>
  );
};

export const GetAsterisk = () => {
  return <span className="required">*</span>;
};

export const GetPadding = (variant: ContactUsPageTypes.TVariant) => {
  return variant === 'newContactUsLightTheme' ? 'pb-5' : 'pb-1';
};

export const GetRadioButtons = (variant: any) => {
  return (
    <Columns className="is-flex-direction-column is-justify-content-center ContactFormRadioGroup">
      <Column
        id="my-radio-group"
        narrow={true}
        className={`py-2  ${
          variant === 'newContactUsLightTheme' ? 'pb-0' : 'pb-4'
        } is-flex  mobile-radio-lable`}
      >
        <span className="question content1">Are you an Existing Tenant?</span>
        <GetAsterisk />
      </Column>
      <Column
        role="group"
        aria-labelledby="my-radio-group"
        className="RadioGroup oy-2 pt-0"
      >
        <label className="RadioLabel is-flex is-align-items-center">
          <Field type="radio" name="IsExistingTenant" value="Yes" checked />
          <span className="pl-3 content1">Yes</span>
        </label>
        <label className="RadioLabel is-flex is-align-items-center ">
          <Field type="radio" name="IsExistingTenant" value="No" />
          <span className="pl-3 content1">No</span>
        </label>
      </Column>
    </Columns>
  );
};

export const GetSubjectDropDown = () => {
  return (
    <Column className="FormControl py-2">
      <label htmlFor="subject">
        Subject
        <GetAsterisk />
      </label>
      <Field as="select" name="subject" className="selectpicker standardInput">
        <option value="I have a question about your services.">
          I have a question about your services.
        </option>
        <option value="I have a question about my existing account.">
          I have a question about my existing account.
        </option>
        <option value="I ran into a technical issue on your website.">
          I ran into a technical issue on your website.
        </option>
      </Field>
    </Column>
  );
};

export const GetMessageBox = ({ variant }: any) => {
  return variant === 'newContactUsLightTheme' ? (
    <fieldset>
      <legend className="pl-1 pr-1">
        Message
        <GetAsterisk />
      </legend>
      <Field
        as="textarea"
        id="messageTextArea"
        name="messageTextArea"
        placeholder="Please enter the message"
        className="textarea"
      />
    </fieldset>
  ) : (
    <div className="is-flex is-flex-direction-column">
      <label>
        Message
        <GetAsterisk />
      </label>
      <Field
        as="textarea"
        id="messageTextArea"
        name="messageTextArea"
        placeholder="Please enter the message"
        className="textarea messageBorder"
      />
    </div>
  );
};

export const GetSendButton = ({ variant, emailAddress }: any) => {
  return (
    <Column
      className={`${
        variant === 'newContactUsDarkTheme' ? 'pt-6' : 'pt-4'
      } mobile-button`}
    >
      <Button
        type="submit"
        color={buttonColor}
        fullwidth={false}
        disabled={emailAddress[0].data ? false : true}
      >
        Send Message
      </Button>
    </Column>
  );
};
